import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import JisEmptyList from "../../components/controls/emptylist";
import Pagenated from "../../components/pagenated";
import moment from "moment";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";
import wordicon from "../../assets/ms_word.png";
import excelicon from "../../assets/ms_excel.png";
import pdficon from "../../assets/pdf.png";

function Report_CaseWaitingAssignmnet() {
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired, setAlert } =
    useContext(ShareContext);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState({});
  const [err, setErr] = useState("");

  const [count, setCount] = useState(0);

  const [openOption, setOpenOption] = useState(false);

  const [roles, setRoles] = useState([]);

  const [selectedCases, setSelectedCases] = useState({});

  useEffect(() => {
    onLoad();
    onLoadRoles();
  }, []);

  useEffect(() => {
    if (pageIndex >= 0) {
      if (!isSearch) {
        onLoad();
      } else {
        onSearch(search);
      }
    } else {
      setPageIndex(0);
    }
  }, [pageIndex, pageSize, search]);

  const onDownload = async (dtype) => {
    const url = `${Constants.apiUrl}/report/awaiting-assignment/${dtype}`;

    // Map doctype to MIME and extension
    const typeMap = {
      excel: {
        mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ext: "xlsx",
      },
      msword: {
        mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ext: "docx",
      },
      pdf: {
        mime: "application/pdf",
        ext: "pdf",
      },
    };

    try {
      setLoading(true);
      const resp = await fetch(url, {
        method: "POST",
        body: JSON.stringify(search),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!resp.ok) throw new Error("Failed to download");

      const blob = await resp.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `report.${typeMap[dtype].ext}`; // Fixed filename
      link.click();
      window.URL.revokeObjectURL(downloadUrl); // Clean up
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Download failed:", error);
    }
  };

  const onSearch = async (sear) => {
    setSearch(sear);
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/report/awaiting-assignment/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/report/awaiting-assignment/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(search),

          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onLoadRoles = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/getrolesBySearch/judge`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setRoles(data.roles);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onDirectSearch = (sear) => {
    console.log("direct search call");
    console.log(sear);
    setSearch(sear);
    setIsSearch(true);
    setPageIndex(0);
  };

  return (
    <div>
      {/* <CaseSearch onSearch={onDirectSearch} frequentData={frequentData} /> */}
      <CustomSearchSortHeader
        onSearch={onDirectSearch}
        frequentData={frequentData}
      />
      <div style={{ textAlign: "right" }}>
        {Object.keys(selectedCases).length > 0 && (
          <JisButton onClick={() => setOpenOption(true)}>
            {" "}
            {Object.keys(selectedCases).length === 1
              ? "Assign (1)"
              : `Bulk Assign (${Object.keys(selectedCases).length})`}
          </JisButton>
        )}
      </div>

      {cases?.length == 0 && <JisEmptyList />}
      {cases?.length > 0 && (
        <>
          <div className="exportdiv">
            <img
              src={wordicon}
              onClick={() => onDownload("msword")}
              style={{ cursor: "pointer" }}
            />
            <img
              src={excelicon}
              onClick={() => onDownload("excel")}
              style={{ cursor: "pointer" }}
            />
            <img
              src={pdficon}
              onClick={() => onDownload("pdf")}
              style={{ cursor: "pointer" }}
            />
          </div>

          <div className="table">
            {/* <div class="section-cases-report">
              <span>Cases Awaiting Assignment</span>
              <div>
                {" "}
                <span
                  className="specialaction"
                  onClick={() => onDownload("excel")}
                >
                  Excel{" "}
                </span>{" "}
                |
                <span
                  className="specialaction"
                  onClick={() => onDownload("msword")}
                >
                  Word
                </span>{" "}
                |
                <span
                  className="specialaction"
                  onClick={() => onDownload("pdf")}
                >
                  PDF
                </span>{" "}
              </div>
            </div> */}
            <div class="section-cases">
              <span>Cases Awaiting Assignment</span>
            </div>
            <div className="table-wrapper">
              <table className="case-table">
                <thead>
                  <tr>
                    <th className="col-title">Suit Number</th>
                    <th className="col-title">Case Title</th>
                    <th className="col-medium">Filing Type</th>
                    <th className="col-medium">Classification</th>
                    <th className="col-medium">Case Age(Days)</th>
                    <th className="col-medium">Date Initiated</th>
                    <th className="col-title">Mode of Process</th>
                  </tr>
                </thead>
                <tbody>
                  {cases?.map((opt, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          backgroundColor: `${
                            Constants.getItemById(
                              frequentData?.casecategories,
                              opt.caseCategoryId,
                            )?.colour
                          }`,
                        }}
                      >
                        {opt.caseNumber || "N/A"}
                      </td>
                      <td>{opt.caseTitle || "N/A"}</td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casetype,
                          opt.caseTypeId,
                        )?.caseType1 || "N/A"}
                      </td>
                      <td>
                        {" "}
                        {Constants.getItemById(
                          frequentData?.casecategories,
                          opt.caseCategoryId,
                        )?.categoryTitle || "N/A"}
                      </td>
                      <td>{moment().diff(opt.createdOn, "days") || "N/A"}</td>
                      <td>
                        {" "}
                        {Constants.momentDate(opt.createdOn).format(
                          "DD MMM, YYYY",
                        ) || "N/A"}
                      </td>
                      <td>{opt.processType || "N/A"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {cases?.length > 0 && (
              <Pagenated
                onChangePageSize={(k) => setPageSize(k)}
                size={pageSize}
                total={count}
                maxPage={20}
                onPick={onPagePick}
              />
            )}
          </div>
        </>
      )}
      <BackLoader open={loading} />
    </div>
  );
}

export default Report_CaseWaitingAssignmnet;
